module.exports = __webpack_public_path__ + "static/media/teen-burger-mb-sept-18_en.c3db6866.jpg";